import React, { createContext } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import DocumentTitle from 'react-document-title';

import { ThemeProvider } from '../styles/theme';
import { loadAppSession } from './state';
import { updateSession } from './session';
import { parseOAuthToken } from '../utils/api';
import AppRouter from './router';
import { RouterType } from '../types/router';
import Preloader from '../containers/Preloader';
import { isDevice } from '../utils/mobile';

import AndroidBackHandler from './components/AndroidBackHandler';
import PushNotificationHandler from './components/PushNotificationHandler';
import ResizeHandler from './components/ResizeHandler';
import EventHandler from './components/EventHandler';

import Notify from '../containers/Notify';
import actions from '../state/actions';

import container from '../container';

const ContainerContext = createContext('container');
export const ContainerProvider = ContainerContext.Provider;
export const ContainerConsumer = ContainerContext.Consumer;

class App extends React.Component {
  componentWillMount() {
    this.handleOAuthRedirect();
    this.loadApplicationSession();
  }

  loadApplicationSession() {
    const { dispatch } = this.props;
    dispatch(loadAppSession(this.props.getCurrentLanguage));

    if (isDevice()) {
      dispatch(actions.overrideCommentAttachments());
    }
  }

  handleOAuthRedirect() {
    const token = parseOAuthToken();

    if (token) {
      const { router: { history } } = this.props;
      updateSession({ accessToken: token.access_token });

      history.replace(history.location.pathname);
    }
  }

  render() {
    const {
      session: { state },
    } = this.props;

    return (
      <ContainerProvider value={container}>
        <ThemeProvider>
          <div>
            <DocumentTitle title="GEMS Access" />
            <AppRouter state={state} />
            <Preloader />
            <EventHandler />
            <AndroidBackHandler />
            <PushNotificationHandler />
            <Notify />
            <ResizeHandler />
          </div>
        </ThemeProvider>
      </ContainerProvider>
    );
  }
}

const mapStateToProps = state => ({ session: state.session });

App.propTypes = {
  session: PropTypes.shape({
    state: PropTypes.string,
  }),
  dispatch: PropTypes.func,
  router: RouterType,
  getCurrentLanguage: PropTypes.func,
};

export default withRouter(connect(mapStateToProps)(App));



// WEBPACK FOOTER //
// ./src/app/index.js